import { EmptyState } from '@vst/beam';
import { Alert } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

export const UnleashedUsageSummaryError = () => {
  const { t } = useTranslation('Usage', { keyPrefix: 'unleashed' });
  const className = `${styles['containerWhite']} ${styles['containerError']}`;

  return (
    <div data-cy="unleashed-usage-summary-loading" className={className}>
      <EmptyState title={t('error')} icon={Alert} />
    </div>
  );
};
